<template>
  <el-dialog
    v-if="visible"
    v-el-drag-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    append-to-body
    width="90%"
    top="8vh"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('vehicleAlarm.overspeedRule.noRuleCar')"
      @close="closeDialog"
    />
    <app-search>
      <div slot="content">
        <el-form inline :model="listQuery" label-suffix="：" label-width="auto">
          <el-row :gutter="10" type="flex" justify="start" align="middle">
            <el-col :span="8">
              <el-form-item :label="$t('public.licensePlate')">
                <el-input
                  v-model="listQuery.licensePlate"
                  :placeholder="$t('public.licensePlate')"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('public.obdCode')">
                <el-input
                  v-model="listQuery.barCode"
                  :placeholder="$t('public.obdCode')"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 清空查询按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>

    <el-table
      ref="tableList"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      row-key="terminalId"
      @row-click="clickRow"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <el-table-column
        type="selection"
        width="55"
        align="center"
        reserve-selection
      />
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{
            scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :min-width="item.width"
        :align="item.position"
        :sortable="item.sortable"
      />
    </el-table>
    <!-- 分页 -->
    <div
      style="padding: 10px 0"
      :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']"
    >
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="closeDialog">{{
        $t("public.cancel")
      }}</el-button>
      <el-button type="primary" @click="submit()">{{
        $t("public.define")
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { overSpeedRuleNoRuleCarUrl, overSpeedRuleAddCarUrl } from '@/api/vehicleAlarm/overspeedRule'
import resolve from '@/api/resolve'
export default {
  name: 'selectCar',
  mixins: [pagingMixin, otherHeight, tableStyle],
  props: {
    visible: Boolean,
    id: String,
    subId: String
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.listLoad()
      }
    }
  },
  data() {
    return {
      listQuery: {},
      tableList: [
        { value: this.$t('public.licensePlate'), prop: 'licensePlate', position: 'center', checked: true, sortable: true },
        { value: this.$t('public.obdCode'), prop: 'barCode', position: 'center', checked: true, sortable: true },
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      multipleSelection: [],
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    listLoad() {
      if (!this.visible) {
        return
      }
      this.listLoading = true
      this.listQuery.id = this.subId
      this.$http.post(overSpeedRuleNoRuleCarUrl, this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    clickRow(row) {
      this.$refs.tableList.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    checkSelection() {
      if (this.multipleSelection.length < 1) {
        this.$alert(this.$t('public.createTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return false
      }
      return true
    },
    submit() {
      if (!this.checkSelection()) return
      this.$http.post(resolve(overSpeedRuleAddCarUrl, this.id), this.multipleSelection.map(row => row.carId))
        .then(({ data }) => {
          if (data.code === 0) {
            this.$emit('add-complete', true)
            this.closeDialog()
          }
        })
    }
  }
}
</script>
